module.exports = __webpack_public_path__ + "static/media/about.2aad8c0d.jpg";